    
    <button 
      pButton
      icon="fa fa-plus"
      [disabled]="!entity || !entity.id"
      pTooltip="{{ 'COMMON.ADD_CHILD_NODE' | translate }}"
      (click)="onAddNode()">
    </button>
  